import React from 'react';
import { Paper, Stack, Box, Typography, Link, Grid } from '@mui/material';
import EditableTextField from './EditableTextField';
import { LeadStatus } from '../../../../utils/enums'

const BasicDetails = ({ data }) => {

    if (!data) {
        // Display a loading indicator or a message if data is not available
        return (
            <Paper elevation={0} sx={{ p: 2, textAlign: 'center' }}>
                {/* <CircularProgress /> */}
                <Typography variant="body2">Loading data...</Typography>
            </Paper>
        );
    }

    return (
        <Paper elevation={0} sx={{ p: 2, width: '100%' }}>
            <Grid container spacing={2} sx={{ marginLeft: -23 }}>
                <Grid item xs={4}>
                    <Typography align="right">Lead Owner:</Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography>{data?.ownerName || '—'}</Typography>
                </Grid>

                <Grid item xs={4}>
                    <Typography align="right">Lead Name:</Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography>{`${data?.firstName || '—'} ${data?.lastName || ''}`}</Typography>
                </Grid>

                <Grid item xs={4}>
                    <Typography align="right">Company:</Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography>{data?.company || '—'}</Typography>
                </Grid>

                <Grid item xs={4}>
                    <Typography align="right">Title:</Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography>{data?.title || '—'}</Typography>
                </Grid>

                <Grid item xs={4}>
                    <Typography align="right">Phone:</Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography>{data?.phone || '—'}</Typography>
                </Grid>

                <Grid item xs={4}>
                    <Typography align="right">Other Phone:</Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography>{data?.otherPhone || '—'}</Typography>
                </Grid>

                <Grid item xs={4}>
                    <Typography align="right">Mobile:</Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography>{data?.mobile || '—'}</Typography>
                </Grid>

                <Grid item xs={4}>
                    <Typography align="right">Email:</Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography>{data?.email || '—'}</Typography>
                </Grid>

                <Grid item xs={4}>
                    <Typography align="right">Secondary Email:</Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography>{data?.secondaryEmail || '—'}</Typography>
                </Grid>

                <Grid item xs={4}>
                    <Typography align="right">Website:</Typography>
                </Grid>
                <Grid item xs={8}>
                    {data?.website ? (
                        <Link
                            href={data.website.trim().startsWith('http') ? data.website.trim() : `https://${data.website.trim()}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            underline="hover"
                        >
                            {data.website}
                        </Link>
                    ) : (
                        <Typography>—</Typography>
                    )}
                </Grid>
            </Grid>
        </Paper>
    )
}

export default BasicDetails;